import { css } from 'styled-components';
import { LoaderSize } from './Loader.enum';
const borderWidths = {
    [LoaderSize.SIZE14]: '1',
    [LoaderSize.SIZE18]: '2',
    [LoaderSize.SIZE22]: '2',
    [LoaderSize.SIZE38]: '3',
    [LoaderSize.SIZE46]: '3',
    [LoaderSize.SIZE62]: '4',
};
const handleLoaderSize = (loaderSize = LoaderSize.SIZE38, isPseudoElement) => css `
  width: ${loaderSize}px;
  height: ${loaderSize}px;
  border-width: ${borderWidths[loaderSize]}px;
  ${isPseudoElement
    ? css `
        top: -${borderWidths[loaderSize]}px;
        left: -${borderWidths[loaderSize]}px;
      `
    : ''};
`;
export default handleLoaderSize;
//# sourceMappingURL=Loader.helpers.js.map